var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt100 ta-c"},[_vm._v("\n  신원인증을 진행합니다.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }